import { Component, ContentChild, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-warning-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './warning-container.component.html',
  styleUrls: ['./warning-container.component.scss'],
})
export class WarningContainerComponent implements OnInit {
  @Input() warningTitle: string = 'Warning';

  @ContentChild('warningContent') warningContent: Element;

  constructor() {}

  ngOnInit(): void {}
}
